import { Link } from 'react-router-dom';

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
}: {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="text-xl text-foreground-950 md:text-2xl">{title}</h2>
        {subtitle && (
          <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-0.5 whitespace-nowrap rounded-full bg-background-100 px-4 py-1.5 text-sm text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}